import { createRef } from 'react';

import type { ToastInterface } from './types';

export const ToastRef = createRef<ToastInterface>();

export const ToastManager: ToastInterface = {
  show: config => ToastRef.current?.show(config),
  hide: () => ToastRef.current?.hide(),
};
